import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Session and conversation state
  sessionId: '',
  conversation: [],
  isLandPageVisible: true,
  isInitialLoading: true,

  // Document selection state
  selectedFabricId: null,
  selectedDocIds: [],

  // Protocol document state (Excel Toolkit)
  protocolDocId: null,
  protocolMarkdownS3Key: null,
  protocolMarkdownContent: null,

  // Sidebar state
  currentSidebarView: 'fabric', // 'fabric' or 'history'
};

const copilotSlice = createSlice({
  name: 'copilot',
  initialState,
  reducers: {

    // ── Session ────────────────────────────────────────────
    setSessionId(state, action) {
      state.sessionId = action.payload;
    },

    setIsInitialLoading(state, action) {
      state.isInitialLoading = action.payload;
    },

    // ── Conversation ───────────────────────────────────────
    setConversation(state, action) {
      state.conversation = action.payload;
    },

    setIsLandPageVisible(state, action) {
      state.isLandPageVisible = action.payload;
    },

    // ── Document Selection ─────────────────────────────────
    setSelectedFabricId(state, action) {
      state.selectedFabricId = action.payload;
    },

    setSelectedDocIds(state, action) {
      state.selectedDocIds = action.payload;
    },

    // ── Protocol Document ─────────────────────────────────
    setProtocolDocId(state, action) {
      state.protocolDocId = action.payload;
    },

    setProtocolMarkdownS3Key(state, action) {
      state.protocolMarkdownS3Key = action.payload;
    },

    setProtocolMarkdownContent(state, action) {
      state.protocolMarkdownContent = action.payload;
    },

    // ── Sidebar ────────────────────────────────────────────
    setCurrentSidebarView(state, action) {
      state.currentSidebarView = action.payload;
    },

    // ── New Conversation (full reset) ──────────────────────
    resetCopilotState() {
      return initialState;
    },
  },
});

export const {
  setSessionId,
  setIsInitialLoading,
  setConversation,
  setIsLandPageVisible,
  setSelectedFabricId,
  setSelectedDocIds,
  setProtocolDocId,
  setProtocolMarkdownS3Key,
  setProtocolMarkdownContent,
  setCurrentSidebarView,
  resetCopilotState,
} = copilotSlice.actions;

// ── Thunk: safe functional update for conversation ─────────
// Reads the LATEST state from the store before applying the updater.
// Critical for streaming where rapid setConversation(prev => ...) calls
// would see stale `conversation` from useSelector.
export const updateConversation = (updater) => (dispatch, getState) => {
  const current = getState().copilot.conversation;
  const newValue = typeof updater === 'function' ? updater(current) : updater;
  dispatch(setConversation(newValue));
};

export default copilotSlice.reducer;